/*-----------------------------------------------------------------
- Market Sort
-----------------------------------------------------------------*/
export default {
    sort_by     : 'مرتب‌سازی بر اساس :',
    sort        : 'مرتب‌سازی',
    sale_count  : 'پرفروش‌ترین',
    newest      : 'جدیدترین',
    rate_average: 'محبوب‌ترین',
    order_by    : 'به صورت :',
    asc         : 'صعودی',
    desc        : 'نزولی',
};
